import { subscribeWithSelector } from "zustand/middleware";
import { createStore } from "zustand/vanilla";
import { getG11nStateCreator } from "./G11nStore";
export var createG11nMemoryStore = function (initialState) {
  return createStore(subscribeWithSelector(getG11nStateCreator(initialState)));
};